import { Autocomplete, TextField } from "@mui/material";
import React from "react";

type Props = {
  label: string;
  inputValue: string;
  noOptionsText: string;
  onChange: (event: any, newValue: any | null) => void;
  setSearchValue: (arg: string) => void;
  options: any[];
  value: any;
};

export default function SearchBarAutocomplete({
  label,
  inputValue,
  noOptionsText,
  onChange,
  setSearchValue,
  options,
  value,
}: Props) {
  return (
    <Autocomplete
      id="searchbar-autocomplete"
      sx={{
        flex: 1,
        height: "100%",
        width: "100%",
        "MuiAutocomplete-root": { width: "100%", height: "100%" },
      }}
      options={options}
      renderInput={(params) => <TextField {...params} label={label} />}
      getOptionLabel={(option) => {
        return typeof option === "string" ? option : option.label;
      }}
      onChange={onChange}
      onInputChange={(event, newInputValue) => {
        setSearchValue(newInputValue);
      }}
      value={value}
      fullWidth
      freeSolo
      noOptionsText={noOptionsText}
    />
  );
}
